/**
 * Slims a filter config's `source` for storage on an applied filter (activeFilter).
 *
 * Applied filters travel: they are JSON.stringified into GET query strings for
 * every discovery request, persisted to sessionStorage, and diffed on each change.
 * The option catalogue (`options` / `groupedOptions`) belongs to the filter config,
 * not to the applied filter — every consumer that renders options resolves the
 * config from the catalogue by `filterId` (groupAnnoFilters / groupDocFilters /
 * useSavedFilterConfig). Only `source.filterType` and the small descriptor keys
 * are read off an applied filter.
 *
 * Keeping the catalogue on the applied filter is not just wasteful, it breaks
 * requests: the "Document Field" filter lists one option per annotation-enabled
 * block across all selected templates, and a tenant with ~80 such blocks pushed
 * the getAnnotations URL past Node's 16 KB header cap (HTTP 431, request never
 * reaches Express). Same class of bug ootils already worked around for
 * `groupedOptions` (see enrichCommonAnnotationFilters).
 */
const BULKY_SOURCE_KEYS = new Set(["options", "groupedOptions", "optionsFn"]);

export const toActiveFilterSource = (source) => {
  if (!source || typeof source !== "object") return source;
  const slim = {};
  for (const [key, value] of Object.entries(source)) {
    if (!BULKY_SOURCE_KEYS.has(key)) slim[key] = value;
  }
  return slim;
};
